import { useMemo } from "react";
var MAS_LIMITE = "MAS_LIMITE";
var CREDIT_CARD = "CREDIT_CARD";
export var useDataPerson = function (responsePerson, responseGetCatalog, cardsOnlyLimit, onlyCreditCard, isVidaActiva) {
    var _a;
    if (cardsOnlyLimit === void 0) { cardsOnlyLimit = false; }
    if (onlyCreditCard === void 0) { onlyCreditCard = false; }
    if (isVidaActiva === void 0) { isVidaActiva = false; }
    var person = Array.isArray(responsePerson)
        ? responsePerson[0]
        : responsePerson;
    var birthDate = useMemo(function () {
        var _a;
        return (_a = person === null || person === void 0 ? void 0 : person.dob) !== null && _a !== void 0 ? _a : "";
    }, [person === null || person === void 0 ? void 0 : person.dob]);
    var gender = useMemo(function () {
        var _a;
        if (!(person === null || person === void 0 ? void 0 : person.catalogGender) || !responseGetCatalog)
            return "";
        var found = responseGetCatalog.find(function (item) { return item.id === person.catalogGender; });
        return (_a = found === null || found === void 0 ? void 0 : found.code) !== null && _a !== void 0 ? _a : "";
    }, [person === null || person === void 0 ? void 0 : person.catalogGender, responseGetCatalog]);
    var creditCardList = useMemo(function () {
        var _a, _b;
        var accounts = (_b = (_a = person === null || person === void 0 ? void 0 : person.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts) !== null && _b !== void 0 ? _b : [];
        var filterRules = [
            {
                enabled: cardsOnlyLimit,
                filter: function (account) { return account.category === MAS_LIMITE; },
            },
            {
                // Solo TC. Si además el flujo es Vida Activa, excluir MAS_LIMITE.
                enabled: onlyCreditCard,
                filter: function (account) {
                    return account.type === CREDIT_CARD &&
                        (!isVidaActiva || account.category !== MAS_LIMITE);
                },
            },
            // Agrega nuevas reglas aquí siguiendo el mismo patrón:
        ];
        var activeRule = filterRules.find(function (rule) { return rule.enabled; });
        var filtered = activeRule ? accounts.filter(activeRule.filter) : accounts;
        return filtered.map(function (account, index) {
            var lastFour = account.number.slice(-4);
            return {
                id: String(index + 1),
                name: "************".concat(lastFour),
                value: lastFour,
                metaData: {
                    // Crudo numérico: el InputNumberFormatAFY que lo renderiza no acepta
                    // prefijos. El símbolo RD$ se agrega en el label desde calculatePremium.
                    montoAprobado: account.approvedAmount
                        ? String(account.approvedAmount)
                        : "0",
                },
            };
        });
    }, [
        (_a = person === null || person === void 0 ? void 0 : person.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts,
        cardsOnlyLimit,
        onlyCreditCard,
        isVidaActiva,
    ]);
    return { birthDate: birthDate, gender: gender, creditCardList: creditCardList };
};
